var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallyHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "happy_wally",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 137.3 208",
    style: {
      enableBackground: "new 0 0 137.3 208"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#DEE1E1;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#D4D7D7;}\n\t.st4{fill:#0D4066;}\n\t.st5{fill:#EE2045;}\n\t.st6{fill:#36C6FF;}\n\t.st7{fill:#49E8AB;}\n\t.st8{fill:#8C52FF;}\n\t.st9{fill:#BF94FF;}\n\t.st10{fill:#3D6EDF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -1596.1149,
    y1: -257.8127,
    x2: -1662.1409,
    y2: -278.5268,
    gradientTransform: "matrix(-1 0 0 1 -1533.3916 348)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DEE1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4D7D7"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.3,69.5c12,8.9,28.2,10.4,42.7,7c5.4-1.3,10.7-3.4,15.6-5.6c3.8-1.6,10.8-7.3,14.3-3.8 c2.3,2.2,2.9,5.9,1.8,8.9c-2.1,5.7-10.7,9.4-15.5,12.4c-7.3,4.5-14.9,8.5-23.1,11.3c-18.7,6.7-40.7,7.3-57.9-2.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.7,72.3c-13-7.2-21.1-21.5-24-36.1c-1-5.4-1.3-11-1.3-16.5c0-4.1,2.2-12.9-2.5-14.6C12,3.8,8.3,4.9,6,7.1 c-4.4,4.2-4.1,13.6-4.8,19.3c-1,8.5-1.5,17.1-0.9,25.6c1.6,19.9,9.9,40.1,26.3,51.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.6,102.1c-2.2,8.5,6.3,13,9.5,16.8c2.9,3.7,6.3,7.9,7,13.6c2.3,18,2.5-4.4,14.3-8.2l18.9,8.2 c-0.4,3.5-8.3,5.1-8.3,5.1c-1.9,2.8-6.7,16.7-7.8,18.3c-9.8,15.6-36,13.3-39.3,12.6c-2.5-0.6-2.3-1.5-0.4,7 c1.9,8.2,3.9,17.8,2.5,23.1c0,0-22.4,9.6-22.7,9.4c-5.4-5.7,1.2-12,1.2-12c-4.2-5.6-16.4-12-27.2-30.7C6.7,134.9,1.2,114,27,61.6 c9.1-18.3,64.9-10.5,55.3,1.6c-1.8,2.2-3.2,4.2-4.7,6.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.9,67.2c14.5,0.4,1.8,13.6,14.3,50.6c8.2,24-3.9,35-16.7,35C3.6,153,9,97,34.6,63.4 C38.3,58.9,47.4,67,52.9,67.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.3,160.1c-1.2,3.8,29.4-1.3,39.8,23.8c-1.9-8.5-3.7-15.5-1.3-15.1c2.6,0.6,18.6,2.1,30.3-4.4 c-6.7,1.9-20,2.6-24.4-1.8c-3.5-3.4,5.1-14.8-5.9-6.9C56.4,166.2,33.5,156.3,32.3,160.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M60.1,82.3c11,5.3,24.3,1.8,31.3-8.5c0.9,2.6,2.3,5.6,5.3,8l-5.3,2.5c0,0-1.8-2.6-1.9-3.4s-6.6,6.3-15.8,6.4 C64.6,87.5,60.1,82.3,60.1,82.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98,55.8c0,0,11.4-5.7,20,3.5c8.6,9.4-0.1,21.2-0.1,21.2s-7.3,12.9-19.3,8.6c-12-4.2-11.3-17-11.3-17l3.2-9.5 L98,55.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101,51.1c0,0,11.4-5.7,20,3.5c8.6,9.4-0.1,21.2-0.1,21.2s-7.3,12.9-19.3,8.6c-12-4.2-11.3-17-11.3-17 l3.2-9.5L101,51.1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,22.3c0,0,0.7-12.7-11.3-17c-12-4.2-19.3,8.6-19.3,8.6s-8.8,11.8-0.2,21.2s20,3.5,20,3.5l7.5-6.7 L56,22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M39,16.9c0,0-0.9-1.5-2.5-2.5c2.2-1.6,5.1-2.6,8.6-1.3c7.8,2.8,7.3,11.1,7.3,11.1l-2.1,6.1l-4.8,4.4 c0,0-7.5,3.8-13-2.3c-4.2-4.7-1.9-10.2-0.6-12.6C31.9,19.8,34.8,15.4,39,16.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M100.9,55c0,0,7.5-3.8,13,2.3c1.5,1.6,2.2,3.2,2.3,4.8c-1.8-1-2.9-0.6-2.9-0.6c2.6,3.2,1.8,6.9,1.5,7.9 c-0.6,1-1,1.6-1,1.6s-3.5,6-9.4,6.1c0.6-0.9,1.5-2.6,1.5-3.9c0,0-2.5,4.2-7.6,1.9c-4.8-3.5-4.5-9.6-4.5-9.6l2.1-6.1L100.9,55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.1,40.1l7.5,28.4l-11.4,7c0,0-6.6,4.5-17.6-2.6c-11-7.2-9.4-15.1-9.4-15.1l1.9-13.3L62.1,40.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M45.3,48.8l14.6,9.6c0.4,0.3,0.6,1,0.3,1.5c-1.6,1.9-6,5.7-13.5,0.7s-4.1-9.4-2.9-11.6 C44.1,48.6,44.9,48.5,45.3,48.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M46.8,60.8c-2.2-1.5-3.7-2.9-4.4-4.7c0.9-0.3,1.8-0.3,2.9,0.1c2.6,1,2.9,2.2,2.9,2.2s1.2-0.3,3.2,1.8 c0.9,0.9,1.2,1.9,1.2,2.9C51,62.8,49.1,62.2,46.8,60.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81,11.8l12.1,8c10.7,7,14.5,21.1,8.8,32.5L91.4,73.5c-7.2,11-21.8,14.3-33.1,7.9l-7-4.5 c3.9-0.6,11.3-2.6,14.2-11.1c4.2-12-8.6-19.3-8.6-19.3S50.3,41,42.5,46c-8.8,5.7-11.3,14.6-10.2,18.6 c-10.4-7.8-7.3-18.7-0.2-29.8l15.7-18.1C56,6.8,70.3,4.7,81,11.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M74.4,21.3c9.4,6.1-0.3,25.4-4.1,29c-3.8,3.5-12.6-3.4-12.6-3.4s-9.8-5.4-8.2-10.2 C51.2,31.6,65.1,15.1,74.4,21.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "49,53.7 57.8,41 57.8,41 60.7,42.9 60.8,43.1 52.2,55.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M89.5,41.6c2.8,1.9,3.5,5.7,1.6,8.5c-0.6,0.9-1.5,1.6-2.3,2.2c-0.7,0.4-1.6-0.3-1.5-1.2 c0.4-2.1,0-3.8-1.2-4.7s-2.9-0.4-4.7,0.7c-0.7,0.4-1.6,0-1.6-0.9c0.1-1,0.4-2.1,1-2.9C82.9,40.6,86.7,39.8,89.5,41.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M54.2,19.1c2.6,1.6,3.2,5.1,1.5,7.8c-0.6,0.9-1.3,1.5-2.1,1.9c-0.7,0.3-1.5-0.3-1.3-1c0.4-1.9,0-3.5-1-4.2 c-1.2-0.7-2.8-0.4-4.2,0.7c-0.6,0.4-1.5,0-1.5-0.7c0.2-0.9,0.4-1.9,0.9-2.8C48.2,18.2,51.8,17.3,54.2,19.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.5,22.4c0,0-18.6-19.9-26.8-22.2c-8.2-2.2-2.6,13.6-2.6,13.6l26.5,9.7L96.5,22.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.1,36c0,0-3.8-18.9-13.9-27.1s-3.7,16.2-3.7,16.2L104.1,36z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallyHappy);
export default __webpack_public_path__ + "static/media/wally_happy.435470bf46d13e14fff97391ff515472.svg";
export { ForwardRef as ReactComponent };